import { useState } from "react";

import { useSelector, useDispatch } from "react-redux";

import useCrmEnrichmentQuota from "app/pages/sales-intelligence/modules/quota/hooks/useCrmEnrichmentQuota";
import { addSettingsDynamicsExportThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/dynamics/export";
import { addSettingsExportThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/hubspot/export";
import { addSettingsSalesForceExportThunk } from "app/pages/sales-intelligence/sub-modules/management/store/effects/salesforce/export";
import type { ExportName, ExportSetting } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import type { Integration } from "app/pages/sales-intelligence/sub-modules/management/types";

import { selectDynamicsCurrentSettings } from "../../../sub-modules/management/store/selectors/dynamics/exportSelectors";
import { selectHsCurrentSettings } from "../../../sub-modules/management/store/selectors/hubspot/exportSelectors";
import { selectSfCurrentSettings } from "../../../sub-modules/management/store/selectors/salesforce/exportSelectors";

import type { UseAddFieldsModalPropsType } from "./type";

const currentSettingsSelectors: Record<Integration, typeof selectSfCurrentSettings> = {
    salesforce: selectSfCurrentSettings,
    hubspot: selectHsCurrentSettings,
    dynamics: selectDynamicsCurrentSettings,
};

export const useAddFieldsModalProps = (
    integrationName: Integration,
    exportName: ExportName,
): UseAddFieldsModalPropsType => {
    const dispatch = useDispatch();
    const [numOfAddedPreFields, setNumOfAddedPreFields] = useState(0);
    const [numOfAddedPreDefinedCreateFields, setNumOfAddedPreDefinedCreateFields] = useState(0);
    const [numOfAddedPreDefinedUpdateFields, setNumOfAddedPreDefinedUpdateFields] = useState(0);
    const [numOfAddedTechnographicsFields, setNumOfAddedTechnographicsFields] = useState(0);

    const { isAvailableHubspotEnrichment } = useCrmEnrichmentQuota();

    const tableData: ExportSetting[] = useSelector(currentSettingsSelectors[integrationName]);

    const addSettings = (settings: string[]) => {
        if (integrationName === "salesforce") {
            return dispatch(addSettingsSalesForceExportThunk(settings, exportName));
        } else if (integrationName === "dynamics") {
            return dispatch(addSettingsDynamicsExportThunk(settings, exportName));
        } else {
            return dispatch(addSettingsExportThunk(settings, exportName, isAvailableHubspotEnrichment));
        }
    };

    return {
        tableData,
        numOfAddedPreFields,
        numOfAddedPreDefinedCreateFields,
        numOfAddedPreDefinedUpdateFields,
        numOfAddedTechnographicsFields,
        addSettings,
        setNumOfAddedPreFields,
        setNumOfAddedPreDefinedCreateFields,
        setNumOfAddedPreDefinedUpdateFields,
        setNumOfAddedTechnographicsFields,
    };
};
